import _defineProperty from "/home/renato/github/renato145.github.io/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/home/renato/github/renato145.github.io/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import { isArray, isBoolean, isString } from 'vega-util';
import { isContinuousFieldOrDatumDef, isFieldDef, isFieldOrDatumDefForTimeFormat } from '../channeldef';
import { fieldDefs } from '../encoding';
import * as log from '../log';
import { isMarkDef } from '../mark';
import { getFirstDefined, hash, unique } from '../util';
import { isSignalRef } from '../vega.schema';
import { toStringFieldDef } from './../channeldef';
export function filterTooltipWithAggregatedField(oldEncoding) {
  var tooltip = oldEncoding.tooltip,
      filteredEncoding = __rest(oldEncoding, ["tooltip"]);

  if (!tooltip) {
    return {
      filteredEncoding: filteredEncoding
    };
  }

  var customTooltipWithAggregatedField;
  var customTooltipWithoutAggregatedField;

  if (isArray(tooltip)) {
    var _iterator = _createForOfIteratorHelper(tooltip),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var t = _step.value;

        if (t.aggregate) {
          if (!customTooltipWithAggregatedField) {
            customTooltipWithAggregatedField = [];
          }

          customTooltipWithAggregatedField.push(t);
        } else {
          if (!customTooltipWithoutAggregatedField) {
            customTooltipWithoutAggregatedField = [];
          }

          customTooltipWithoutAggregatedField.push(t);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    if (customTooltipWithAggregatedField) {
      filteredEncoding.tooltip = customTooltipWithAggregatedField;
    }
  } else {
    if (tooltip['aggregate']) {
      filteredEncoding.tooltip = tooltip;
    } else {
      customTooltipWithoutAggregatedField = tooltip;
    }
  }

  if (isArray(customTooltipWithoutAggregatedField) && customTooltipWithoutAggregatedField.length === 1) {
    customTooltipWithoutAggregatedField = customTooltipWithoutAggregatedField[0];
  }

  return {
    customTooltipWithoutAggregatedField: customTooltipWithoutAggregatedField,
    filteredEncoding: filteredEncoding
  };
}
export function getCompositeMarkTooltip(tooltipSummary, continuousAxisChannelDef, encodingWithoutContinuousAxis) {
  var withFieldName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  if ('tooltip' in encodingWithoutContinuousAxis) {
    return {
      tooltip: encodingWithoutContinuousAxis.tooltip
    };
  }

  var fiveSummaryTooltip = tooltipSummary.map(function (_ref) {
    var fieldPrefix = _ref.fieldPrefix,
        titlePrefix = _ref.titlePrefix;
    var mainTitle = withFieldName ? " of ".concat(getTitle(continuousAxisChannelDef)) : '';
    return {
      field: fieldPrefix + continuousAxisChannelDef.field,
      type: continuousAxisChannelDef.type,
      title: isSignalRef(titlePrefix) ? {
        signal: "".concat(titlePrefix, "\"").concat(escape(mainTitle), "\"")
      } : titlePrefix + mainTitle
    };
  });
  var tooltipFieldDefs = fieldDefs(encodingWithoutContinuousAxis).map(toStringFieldDef);
  return {
    tooltip: [].concat(_toConsumableArray(fiveSummaryTooltip), _toConsumableArray(unique(tooltipFieldDefs, hash)))
  };
}
export function getTitle(continuousAxisChannelDef) {
  var title = continuousAxisChannelDef.title,
      field = continuousAxisChannelDef.field;
  return getFirstDefined(title, field);
}
export function makeCompositeAggregatePartFactory(compositeMarkDef, continuousAxis, continuousAxisChannelDef, sharedEncoding, compositeMarkConfig) {
  var scale = continuousAxisChannelDef.scale,
      axis = continuousAxisChannelDef.axis;
  return function (_ref2) {
    var partName = _ref2.partName,
        mark = _ref2.mark,
        positionPrefix = _ref2.positionPrefix,
        _ref2$endPositionPref = _ref2.endPositionPrefix,
        endPositionPrefix = _ref2$endPositionPref === void 0 ? undefined : _ref2$endPositionPref,
        _ref2$extraEncoding = _ref2.extraEncoding,
        extraEncoding = _ref2$extraEncoding === void 0 ? {} : _ref2$extraEncoding;
    var title = getTitle(continuousAxisChannelDef);
    return partLayerMixins(compositeMarkDef, partName, compositeMarkConfig, {
      mark: mark,
      encoding: Object.assign(Object.assign(Object.assign(_defineProperty({}, continuousAxis, Object.assign(Object.assign(Object.assign({
        field: "".concat(positionPrefix, "_").concat(continuousAxisChannelDef.field),
        type: continuousAxisChannelDef.type
      }, title !== undefined ? {
        title: title
      } : {}), scale !== undefined ? {
        scale: scale
      } : {}), axis !== undefined ? {
        axis: axis
      } : {})), isString(endPositionPrefix) ? _defineProperty({}, "".concat(continuousAxis, "2"), {
        field: "".concat(endPositionPrefix, "_").concat(continuousAxisChannelDef.field)
      }) : {}), sharedEncoding), extraEncoding)
    });
  };
}
export function partLayerMixins(markDef, part, compositeMarkConfig, partBaseSpec) {
  var clip = markDef.clip,
      color = markDef.color,
      opacity = markDef.opacity;
  var mark = markDef.type;

  if (markDef[part] || markDef[part] === undefined && compositeMarkConfig[part]) {
    return [Object.assign(Object.assign({}, partBaseSpec), {
      mark: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, compositeMarkConfig[part]), clip ? {
        clip: clip
      } : {}), color ? {
        color: color
      } : {}), opacity ? {
        opacity: opacity
      } : {}), isMarkDef(partBaseSpec.mark) ? partBaseSpec.mark : {
        type: partBaseSpec.mark
      }), {
        style: "".concat(mark, "-").concat(String(part))
      }), isBoolean(markDef[part]) ? {} : markDef[part])
    })];
  }

  return [];
}
export function compositeMarkContinuousAxis(spec, orient, compositeMark) {
  var encoding = spec.encoding;
  var continuousAxis = orient === 'vertical' ? 'y' : 'x';
  var continuousAxisChannelDef = encoding[continuousAxis]; // Safe to cast because if x is not continuous fielddef, the orient would not be horizontal.

  var continuousAxisChannelDef2 = encoding["".concat(continuousAxis, "2")];
  var continuousAxisChannelDefError = encoding["".concat(continuousAxis, "Error")];
  var continuousAxisChannelDefError2 = encoding["".concat(continuousAxis, "Error2")];
  return {
    continuousAxisChannelDef: filterAggregateFromChannelDef(continuousAxisChannelDef, compositeMark),
    continuousAxisChannelDef2: filterAggregateFromChannelDef(continuousAxisChannelDef2, compositeMark),
    continuousAxisChannelDefError: filterAggregateFromChannelDef(continuousAxisChannelDefError, compositeMark),
    continuousAxisChannelDefError2: filterAggregateFromChannelDef(continuousAxisChannelDefError2, compositeMark),
    continuousAxis: continuousAxis
  };
}

function filterAggregateFromChannelDef(continuousAxisChannelDef, compositeMark) {
  if (continuousAxisChannelDef === null || continuousAxisChannelDef === void 0 ? void 0 : continuousAxisChannelDef.aggregate) {
    var aggregate = continuousAxisChannelDef.aggregate,
        continuousAxisWithoutAggregate = __rest(continuousAxisChannelDef, ["aggregate"]);

    if (aggregate !== compositeMark) {
      log.warn(log.message.errorBarContinuousAxisHasCustomizedAggregate(aggregate, compositeMark));
    }

    return continuousAxisWithoutAggregate;
  } else {
    return continuousAxisChannelDef;
  }
}

export function compositeMarkOrient(spec, compositeMark) {
  var mark = spec.mark,
      encoding = spec.encoding;
  var x = encoding.x,
      y = encoding.y;

  if (isMarkDef(mark) && mark.orient) {
    return mark.orient;
  }

  if (isContinuousFieldOrDatumDef(x)) {
    // x is continuous
    if (isContinuousFieldOrDatumDef(y)) {
      // both x and y are continuous
      var xAggregate = isFieldDef(x) && x.aggregate;
      var yAggregate = isFieldDef(y) && y.aggregate;

      if (!xAggregate && yAggregate === compositeMark) {
        return 'vertical';
      } else if (!yAggregate && xAggregate === compositeMark) {
        return 'horizontal';
      } else if (xAggregate === compositeMark && yAggregate === compositeMark) {
        throw new Error('Both x and y cannot have aggregate');
      } else {
        if (isFieldOrDatumDefForTimeFormat(y) && !isFieldOrDatumDefForTimeFormat(x)) {
          // y is temporal but x is not
          return 'horizontal';
        } // default orientation for two continuous


        return 'vertical';
      }
    }

    return 'horizontal';
  } else if (isContinuousFieldOrDatumDef(y)) {
    // y is continuous but x is not
    return 'vertical';
  } else {
    // Neither x nor y is continuous.
    throw new Error("Need a valid continuous axis for ".concat(compositeMark, "s"));
  }
}